module.exports = __webpack_public_path__ + "static/media/VERSION.146e1c5e.bin";